import { RANGES, type RangeName } from './range'

/**
 * Capul de perete al tablourilor Easeedesk: sigla, titlul, si casuta de
 * perioada din coltul din stanga sus.
 *
 * Aceleasi masuri si aceleasi culori ca machetele vechi
 * (`views/version-3/dashboards/easeedesk/<ecran>/index.php`), unde blocul asta
 * era copiat cuvant cu cuvant in fiecare ecran. Aici e scris o data.
 *
 * In locul calendarului din `.reportrange` sunt cele sase scurtaturi ale lui:
 * `daterangepicker` nu e in v4, iar fara nicio casuta tabloul ar fi aratat
 * mereu ziua curenta.
 */
export function WallHeader({
  title,
  rangeName,
  onRange,
}: {
  title: string
  rangeName?: RangeName
  onRange?: (next: RangeName) => void
}) {
  return (
    <div id="row" style={{ marginTop: '-20px' }}>
      <h1 style={{ fontSize: '20px', textAlign: 'center', width: '100%' }}>
        <img src="/td/images/logo/logo.png" style={{ height: 'auto', margin: 'auto', display: 'block' }} alt="" />
        <br />
        <b style={{ color: '#57636F' }}>{title}</b>
        {onRange && rangeName ? (
          <div
            className="pull-left"
            style={{ fontSize: 12, marginLeft: -8, marginTop: -40, width: '11.5%', position: 'absolute' }}
          >
            <div className="reportrange" style={{ padding: 8, color: '#FFF', background: '#616F7B', height: 40 }}>
              <i className="fas fa-calendar" aria-hidden="true"></i>&nbsp;
              <select
                aria-label="Date range"
                value={rangeName}
                onChange={(e) => onRange(e.target.value as RangeName)}
                style={{
                  textTransform: 'uppercase',
                  color: '#FFF',
                  background: 'transparent',
                  border: 0,
                  fontSize: 12,
                  cursor: 'pointer',
                }}
              >
                {RANGES.map((name) => (
                  <option key={name} value={name} style={{ color: '#000' }}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ) : null}
      </h1>
    </div>
  )
}

/** Panglica galbena cand tabelele ecranului nu exista pe baza asta. */
export function NotInstalled({ what }: { what: string }) {
  return (
    <div className="alert alert-warning" style={{ clear: 'both' }}>
      <i className="fas fa-exclamation-triangle" aria-hidden="true"></i> The {what} tables are not installed on this
      database, so there are no numbers to show.
    </div>
  )
}
